import { Button } from "@mui/material";
import makeStyles from "../../../makeStylesV4Compat";
import { Link } from "react-router-dom";
import { CloseCircleIcon } from "src/components/AssembleIcons/Brand/CloseCircleIcon";
import { AssembleTypography } from "../../AssembleTypography";

const useStyles = makeStyles(() => ({
  button: {
    height: "2rem",
    width: "5rem",
  },
}));

export function HRISLocationsLinkClose(): JSX.Element {
  const classes = useStyles();

  return (
    <Button
      className={classes.button}
      component={Link}
      variant="outlined"
      to="#"
      endIcon={<CloseCircleIcon />}
    >
      <AssembleTypography variant="productParagraphSmall">
        Close
      </AssembleTypography>
    </Button>
  );
}
